// BaseCard.ts
import { Vue, Component, Prop, InjectReactive } from 'vue-property-decorator';

@Component
export default class BaseCard extends Vue {
    /**
     * Titre commun à toutes les cartes
     */
    @Prop({ default: () => "" })
    public TitleKey!: string;

    /**
     * Icône commune à toutes les cartes
     */
    @Prop({ default: () => "" })
    public IconName!: string;

    /** * Variant de couleur injecté 
     */
    @InjectReactive()
    public Variant!: string;
}